<script>
import Vue from 'vue'
import Store from '../../services/lstorage'
// import TorneoChess from './torneo'
import Board from '../../services/board'
// import Chessground from 'chessground'
import UserService from '../../services/user'
import TorneoService from '../../services/torneo'
import Chess from 'chess.js'
import Swiss from '../../services/swiss.min.js'
import toast from 'vue-material-components'
import Jquery from 'jquery'
import BoardVisorSmall from '../game/boardVisorSmall'

var groundInit = 1
// var groundFinish = 1
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  route: {
    canActivate: function (transition) {
      return UserService.user_acces('authenticate') ? true : transition.redirect('user/loguin')
    },
    data (transition) {
      return Promise.all([
        TorneoService.count(this)
      ]).then(function (data) {
        const theD = JSON.parse(data)
        // window.alert(JSON.stringify(theD))
        return {
          counts: theD
        }
      }, function (response) {
        // window.alert('no se pudo contar')
      })
    }
  },
  template: require('./template.html'),
  data () {
    return {
      user: UserService.getUser(),
      mode: 'add',
      fenInit: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      fenFinish: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      pgn: '',
      startPlay: 0,
      club: '',
      numMoves: 1,
      timeMove: 60,
      titleFen: 'Torneo',
      myPGNValue: '',
      myFENValue: '',
      results: {},
      pgnFiles: [],
      item: {
        num: 0
      },
      counts: [],
      foundList: [],
      chess: new Chess(),
      torneoType: {},
      torneosType: [
        /* {
          numMoves: 1,
          type: 'MateIn1',
          description: 'Las blancas ganan en un movimiento',
          position: false
        },*/
        {
          numMoves: 0,
          timeMove: 120,
          type: 'Liga',
          description: 'Torneo todos contra todos.',
          position: true
        },
        {
          numMoves: 0,
          timeMove: 120,
          type: 'Simultanea',
          description: 'Un jugador contra muchos otros.',
          position: true
        },
        {
          numMoves: 0,
          timeMove: 120,
          type: 'Suizo',
          description: 'Sistema suizo a varias rondas',
          position: true
        },
        {
          numMoves: 0,
          timeMove: 120,
          type: 'Aleatorio',
          description: 'Cada ronda es aleatoria',
          position: true
        },
        {
          numMoves: 0,
          timeMove: 120,
          type: 'Arena',
          description: 'Va emparejando jugadores en función de su elo y puntuación en el torneo.',
          position: true
        }
      ],
      torneos: [],
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      classBoard: '',
      finduser: '',
      conectados: true,
      bGuardar: false,
      sendToAll: false,
      dirActionUpload: Store.get('serverDir') + '/chat/upload',
      dirServer: Store.get('serverDir'),
      filesUpload: [],
      hashFileBoard1: '',
      hashFileBoard2: '',
      hashFileBoard3: '',
      fileProgress: 0,
      allFilesUploaded: true,
      offcanvas: false,
      active: 'boardVisor',
      tab: '0',
      tabs: [],
      chattext: '',
      boards: [],
      boardFiles: [],
      boardFilesName: '',
      boardFiles2: [],
      boardFilesName2: '',
      boardFiles3: [],
      boardFilesName3: '',
      rondas: 1,
      rondaactual: 1,
      nombretorneo: 'Torneo 1',
      nombreTorneoResult: 'Torneo 1',
      newboard: {
        color: 'w',
        time: '3',
        incremento: 0,
        elo: 1500,
        contrincante: '',
        public: true,
        broadcast: false,
        all: true,
        club: ''
      },
      todosCheck: false,
      users: [],
      usersConnected: [],
      players: [],
      playersResult: [],
      round1: {
        rounds: []
      },
      bSimultanea: false,
      bRandColor: false,
      bOneRound: true,
      usersLength: 0,
      games: [],
      board: Store.get('boardSee', {}),
      totalRecords: 0,
      limit: 100,
      filters: {
        torneo: 'Primera liga',
        ronda: '1'
      }
     // userClubData: {}
    }
  },
  mixins: [
    toast
  ],
  components: {
    // TorneoChess,
    BoardVisorSmall
  },
  events: {
    boards (data) {
      this.boards = data.boards
    },
    mensaje (data) {
      this.recibeMensaje(data.men, true, true)
      if (data.men.send !== this.user.username) {
        this.chatRecibido = true
      }
    },
    updateBoards (classBoard) {
      this.classBoard = classBoard
    },
    users (data) {
      // window.alert(data)
      this.usersConnected = data.nicknames
      const dataSend = {
        club: this.user.club
      }
      const _self = this
      UserService.getAll(this, dataSend).then(function (response) {
        const dd = JSON.parse(response)
        const updatedUsers = dd.filter(user => {
          const existingUser = _self.users.find(u => u.username === user.username)
          return !existingUser ||
            existingUser.elo !== user.elo
        })
        if (updatedUsers.length > 0) {
          _self.users = dd
          const playersParam = { ..._self.players } // Copia el estado actual de players
          updatedUsers.forEach(user => {
            if (true) {
              const nombre = user.username
              // Verifica si playersParam[nombre] existe, si no, inicialízalo como un objeto vacío
              if (!playersParam[nombre]) {
                playersParam[nombre] = {}
              }
              playersParam[nombre] = {
                name: nombre,
                juega: _self.isConnected(nombre),
                user: user._id || null,
                score: playersParam[nombre].score || 0, // Mantiene el puntaje actual si existe
                buchholz: playersParam[nombre].buchholz || 1, // Mantiene buchholz actual si existe
                elo: user.elo
              }
            }
          })
          playersParam['PC'] = playersParam['PC'] || {
            name: 'PC',
            juega: false,
            user: null,
            score: 0,
            buchholz: 1,
            elo: 1500
          }
          // window.alert(playersParam.length)
          _self.players = playersParam
        }
      }, function (response) {
        // Manejo de errores
        console.error('Error al obtener datos de usuarios:', response)
      })
    }
  },
  methods: {
    createGuid () {
      function _p8 (s) {
        var p = (Math.random().toString(16) + '000000000').substr(2, 8)
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
      }
      return _p8()//  + _p8(true) + _p8(true) + _p8()
    },
    recibeMensaje (men, bottom = false, toast = true) {
      // var idDiv = 'chatConvertGame'
      // var divScroll = document.getElementById(idDiv)
      // var atBottom = divScroll.scrollTop >= divScroll.scrollHeight - divScroll.clientHeight
      // window.alert(JSON.stringify(men))
      if (men.board === 'Retransmisión') {
        // window.alert(JSON.stringify(men))
        this.mensjGame.push(men)
        if (bottom) {
          this.isAtBottom()
        }
      }
      if (toast === true) {
        if (men.send !== UserService.getUser().username) {
          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000)
        }
      }
    },
    allAreConnected (round) {
      var ret = true
      if (this.item !== undefined && this.item.round1 !== undefined) {
        // for (var i in this.item.round1) {
        for (var play in this.item.round1[round].rounds) {
          if (this.item.round1[round].rounds[play].white/* .substring(0, 2) */ !== 'PC' && this.item.round1[round].rounds[play].black/* .substring(0, 2) */ !== 'PC') {
            if (this.isConnected(this.item.round1[round].rounds[play].white) === false) {
              ret = false
              break
            }
            if (this.isConnected(this.item.round1[round].rounds[play].black) === false) {
              ret = false
              break
            }
          }
        }
        // }
      }
      return ret
    },
    isBeginRonda (rondaParam) {
      var ret = false
      var nRonda = 0
      for (var ronda in this.item.round1) {
        if (nRonda + 1 === rondaParam) {
          for (var partida in this.item.round1[ronda].rounds) {
            if (this.item.round1[ronda].rounds[partida].wins !== '') {
              ret = true
            }
          }
        }
        nRonda++
      }
      return ret
    },
    isBegin () {
      var ret = false
      for (var ronda in this.item.round1) {
        for (var partida in this.item.round1[ronda].rounds) {
          if (this.item.round1[ronda].rounds[partida].wins !== '') {
            ret = true
          }
        }
      }
      return ret
    },
    isConnected (userName) {
      var ret = false
      if (userName/* .substring(0, 2) */ === 'PC') {
        ret = true
      } else {
        for (var i in this.usersConnected) {
          if (this.usersConnected[i].club === this.user.club) {
            var nombre = this.usersConnected[i].username
            if (nombre === userName) {
              ret = true
              break
            }
          }
        }
      }
      return ret
    },
    FilterTorneo (torneo, ronda) {
      var filters = {
        filters: this.filters,
        torneo: torneo.titlefen,
        ronda: ronda.toString()
      }
      var self = this
      Board.filtertorneo(self, filters).then(function (response) {
        // window.alert(JSON.stringify(torneo) + ' - ' + ronda)
        const data = JSON.parse(response)
        self.totalRecords = 0
        // self.foundList = data.documents
        // window.alert(JSON.stringify(data.documents))
        var number = 0
        var bRet = true
        for (var i in torneo.round1) {
          for (var play in torneo.round1[i].rounds) {
            // window.alert(self.item.round1[i].rounds[play].white + ' - ' + a.u1 + ' / ' + self.item.round1[i].rounds[play].black + ' - ' + a.u2)
            if (torneo.round1[i].rounds[play].white/* .substring(0, 2) */ === 'PC' && torneo.round1[i].rounds[play].black/* .substring(0, 2) */ === 'PC' && torneo.round1[i].rounds[play].wins === '') {
              torneo.round1[i].rounds[play].wins = Math.random() % 2 ? 'white' : 'black'
              var result = Math.floor(Math.random() * (1 - (-1) + 1)) + (-1)
              if (result === 1) {
                torneo.round1[i].rounds[play].wins = 'white'
              }
              if (result === -1) {
                torneo.round1[i].rounds[play].wins = 'black'
              }
              if (result === 0) {
                torneo.round1[i].rounds[play].wins = 'draw'
              }
              number++
              // window.alert(JSON.stringify(torneo.round1[i].rounds[play].white))
              bRet = true
            }
          }
        }
        // window.alert(JSON.stringify(torneo))
        self.foundList = data.documents.filter(function (a) {
          if (torneo !== undefined && torneo.round1 !== undefined && torneo.titlefen === a.torneo) {
            // window.alert(JSON.stringify(torneo.round1))
            for (var i in torneo.round1) {
              // window.alert(JSON.stringify(i))
              for (var play in torneo.round1[i].rounds) {
                // window.alert(JSON.stringify(play))
                // window.alert(self.item.round1[i].rounds[play].white + ' - ' + a.u1 + ' / ' + self.item.round1[i].rounds[play].black + ' - ' + a.u2)
                if (parseInt(i) === a.ronda && torneo.round1[i].rounds[play].white === a.u1 && torneo.round1[i].rounds[play].black === a.u2) {
                  torneo.round1[i].rounds[play].wins = a.wins
                  number++
                  bRet = true
                }
              }
            }
          }
          return bRet
        })
        self.totalRecords = number
        // window.alert('Total de partidas: ' + self.totalRecords)
        // window.alert(JSON.stringify(self.totalRecords))
      }, function (response) {
        self.error = response.data
      })
      // this.skip = 0
      // window.alert(this.totalRecords)
    },
    selectItm (item) {
      // window.alert(JSON.stringify(item))
      this.totalRecords = 0
      this.item = item
      this.FilterTorneo(this.item, 0)
      if (this.item !== undefined && this.item.round1 !== undefined) {
        this.item.round1 = JSON.parse(item.round1)
      }
    },
    nextTorneo () {
      var post = this.torneos.indexOf(this.item)
      if (post !== -1 && (post + 1) < this.torneos.length && this.torneos[post + 1]) {
        this.selectItm(this.torneos[post + 1])
      } else {
        if (((post + 1) >= this.torneos.length) && ((this.torneosType.indexOf(this.torneoType) + 1) < this.torneosType.length)) {
          this.selectTorneoType(this.torneosType[this.torneosType.indexOf(this.torneoType) + 1])
        } else {
          this.toast('<span>Ya no hay mas</span>', 2000)
        }
      }
    },
    selectTorneoType (torneo) {
      this.torneoType = torneo
      var parms = {
        type: torneo.type, club: this.user.club
      }
      if (torneo.type === 'Simultanea') {
        this.bSimultanea = true
      } else {
        this.bSimultanea = false
      }
      this.item.round1 = []
      var _self = this
      TorneoService.get(_self, parms).then(function (response) {
        const theD = JSON.parse(response)
        _self.torneos = theD
        setTimeout(function () {
          if (_self.torneos.length > 0 && _self.torneos[0]) {
            _self.selectItm(_self.torneos[0])
          }
          Jquery('#listSomeTorneos').animate({
            'scrollTop': 0
          }, 'slow')
        }, 50)
      }, function (response) {
        this.error = response.data
      })
    },
    updateFenInit (orig, dest) {
      this.chess.move({
        from: orig,
        to: dest
      })
      // window.alert(groundInit.getFen())
      this.fenInit = groundInit.getFen()
    },
    updateFenFinish (orig, dest) {
      this.chess.move({
        from: orig,
        to: dest
      })
      // this.fenFinish = groundFinish.getFen()
    },
    addTorneo (mode) {
      this.mode = mode
      // window.alert('teest')
      if (!this.torneoType.type) {
        this.toast('<span>Selecciona un tipo de torneo</span>', 2000)
        return
      }
      if (mode === 'add') {
        this.round1 = {}
        this.nombretorneo = 'T_' + this.createGuid()
      }
      // this.addPlayersInRound(this.round1)
      this.$broadcast('modal::open', 'modalCreateTorneo')
      /* var options = {
        fen: this.fenInit,
        orientation: 'white',
        movable: {
          free: true,
          events: {
            after: this.updateFenInit
          }
        }
      }*/
      /* setTimeout(function () {
        // groundInit = Chessground(document.getElementById('torneoGenerateFenInit'), options)
        var pgnBoardInit = 0
        if (document.getElementById('pgnMoves')) {
          document.getElementById('pgnMoves').textContent = ''
        }
        if (document.getElementById('pgnButtons')) {
          document.getElementById('pgnButtons').textContent = ''
        }
        if (document.getElementById('pgnHeader')) {
          document.getElementById('pgnHeader').textContent = ''
        }
        var pos = 'start' // board.fen !== undefined ? board.fen : 'end'
        var start = 'start'
        var pgnNew = this.pgn.split('"]').join('"]\n')
        pgnNew = pgnNew.split('{}').join('')
        var headers = this.parse_pgn_header(pgnNew)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          pos = headers['FEN']
        } else {
          // window.alert(board.fen + ' ' + start)
        }
        if (start === pos) {
          start = 0
        }
        if (this.fenInit !== '' && this.fenInit !== undefined) {
          start = this.fenInit
        }
        try {
          pgnBoardInit = window.pgnEdit({inner: 'torneoGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons', header: 'pgnHeader'}, {pgn: this.pgn, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true})
          groundInit = pgnBoardInit.board
          window.pgnBoardBase = pgnBoardInit.boardBase
          window.ground = pgnBoardInit.board
        } catch (error) {
          // this.toast('<span>' + 'Error (AddTorneo): ' + error + '</span>', 3000)
          console.error('<span>' + 'Error (AddTorneo): ' + error + '</span>', 3000)
        }
        // window.alert(pgnBoardInit.boardBase.currentMove)
        /* setTimeout(function () {
          document.getElementById('pgnButtonslast').click()
        }, 100)*/
        // groundInit.set(options)
        /* if (this.torneoType.position) {
          var optionsF = {
            fen: this.fenFinish,
            orientation: 'white',
            movable: {
              free: true,
              events: {
                after: this.updateFenFinish
              }
            }
          }
          var pgnBoard = 0
          pgnBoard = window.pgnBoard({inner: 'torneoGenerateFenFinish'}, {position: this.fenFinish, showCoords: false, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true})
          groundFinish = pgnBoard.board
          groundFinish.set(optionsF)
          // groundFinish = Chessground(document.getElementById('torneoGenerateFenFinish'), optionsF)
        }*
      }.bind(this), 500)*/
    },
    generateHeader (pgnFile, complete = true, onlyNames = false) {
      var retHeader = ''
      var pgnInLines = pgnFile.split('"]').join('"]\n')
      var headers = this.parse_pgn_header(pgnInLines)
      if (headers !== undefined && headers['Event'] !== undefined) {
        var appendHeader = function (result, headers, separator) {
          if (headers && headers.length > 0) {
            if (result.length > 0) {
              result += separator
            }
            result += headers
          }
          return result
        }
        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']] // , headers['ECO'], headers['Result']]
        if (complete) {
          retHeader = headers['White'] + ' vs ' + headers['Black']
          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']]
        }
        if (onlyNames) {
          retHeader = headers['White'] + ' (' + headers['WhiteElo'] + ')' + ' vs ' + headers['Black'] + ' (' + headers['BlackElo'] + ')'
          hh = []
        }
        if (hh.length > 1) {
          var rest = ''
          retHeader += ' ('
          hh.forEach(function (headers) {
            rest = appendHeader(rest, headers, ' | ')
          })
          retHeader += rest
          retHeader += ')'
        }
        // window.alert(retHeader)
      }
      // retHeader = decodeURIComponent(escape(retHeader))
      return retHeader
    },
    readTextFile (file, callback, encoding) {
      var reader = new window.FileReader()
      reader.addEventListener('load', function (e) {
        callback(this.result)
      })
      if (encoding) {
        reader.readAsText(file, encoding)
      } else {
        reader.readAsText(file)
      }
    },
    isListFiles () {
      var input = document.getElementById('files')
      if (input.files && input.files[0] && input.files[0].length > 0) {
        return true
      }
      return false
    },
    listFiles () {
      this.fileChosen()
    },
    hashCode (s) {
      var h = 0
      var l = s.length
      var i = 0
      if (l > 0) {
        while (i < l) {
          h = (h << 5) - h + s.charCodeAt(i++) | 0
        }
      }
      var hexString = h.toString(16)
      return hexString
    },
    parsePgnFiles (file, number) {
      this.pgnFiles = ''
      var newlineChar = '\r?\n'
      var filesObj = {}
      // file = file.replace(/\{( *)\}/gmu, '')
      // file = file.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      var lines = file.split(new RegExp(newlineChar))
      var pgntext = ''
      var state = 0 // 0 header, 1 moves
      var index = 0
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].length > 0) {
          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
            if (state === 1) {
              index = index + 1
              var headers = this.parse_pgn_header(pgntext)
              var hashCode = this.hashCode(pgntext)
              var board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' }
              filesObj[index] = board
              // window.alert(JSON.stringify(filesObj[index]))
              pgntext = ''
            }
            state = 0
          } else {
            state = 1
          }
          if (state === 0) {
            pgntext += lines[i] + '\r\n'
          } else {
            pgntext += lines[i] + ' '
          }
        }
      }
      headers = this.parse_pgn_header(pgntext)
      hashCode = this.hashCode(pgntext)
      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' }
      index = index + 1
      filesObj[index] = board
      // window.alert(JSON.stringify(filesObj[index]))
      // filesObj[i] = pgntext
      this.pgnFiles = filesObj
      // this.$broadcast('modal::close', 'some ', 'modalCreateTorneo')
      // this.$broadcast('modal::open', 'pgnFilesModal')
      return filesObj
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    deleteComment (pgn) {
      pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      return pgn
    },
    cleanPGNContent (str) {
      return str.replace(/(\r?\n){2,}/g, '\n\n') // Mantener exactamente dos saltos entre partidas
        .replace(/\r?\n/g, (match, offset, string) => {
          const prevChar = string[offset - 1]
          const nextChar = string[offset + 1]
          // Si está entre partidas (dos saltos consecutivos), mantener el salto
          if (prevChar === '\n') {
            return match // No modificar, es parte de la separación entre partidas
          }
          // Si está dentro de los movimientos o comentarios
          if (prevChar === ']' || nextChar === '[') {
            return match // Mantener el salto de línea
          }
          return ' ' // Reemplazar con un espacio
        }).replace(/ {2,}/g, ' ') // Eliminar espacios dobles
    },
    prettyPgn (strParam) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*/
      // window.alert(str)
      // str = decodeURIComponent((str))
      var str = strParam
      try {
        // Intentar decodificar la cadena como UTF-8
        str = Buffer.from(strParam, 'latin1').toString('utf8')
      } catch (e) {
        str = strParam
      }
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O') // .replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = this.cleanPGNContent(str)
      return str
    },
    openPGN (pgnText) {
      // var output = document.getElementById('idTextAreaPGN')
      // var idFEN = document.getElementById('myFENValue')
      // output.value = pgnText
      // output.textContent = pgnText
      // window.alert(output.value)
      // idFEN.value = ''
      // idFEN.textContent = ''
      // idFEN.dispatchEvent(new window.Event('input'))
      var pgnAux = pgnText
      pgnAux = this.prettyPgn(pgnAux)
      // pgnAux = this.deleteComment(pgnAux)
      // pgnAux = pgnAux.replace('0-0', 'O-O')
      // pgnAux = pgnAux.replace('0-0-0', 'O-O-O')
      // pgnAux = pgnAux.replace(/\{( *)\}/gmu, '')
      // pgnAux = pgnAux.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      this.myPGNValue = pgnAux
      // output.dispatchEvent(new window.Event('change'))
      // this.$broadcast('modal::close', 'some', 'pgnFilesModal')
      // this.changePGNTextArea()
    },
    fileChosen () {
      var output = document.getElementById('idTextAreaPGN')
      var input = document.getElementById('files')
      var _self = this
      if (input.files && input.files[0]) {
        this.readTextFile(input.files[0],
          function (str) {
            if (output !== undefined) {
              output.value = ''
              output.dispatchEvent(new window.Event('change'))
            }
            _self.parsePgnFiles(str)
          }, 'ISO-8859-1'
        )
      }
    },
    changePGNTextArea () {
      var idTextArea = document.getElementById('idTextAreaPGN')
      if (idTextArea && idTextArea.value !== 'none') {
        var pgnAux = idTextArea.value
        pgnAux = pgnAux.replace('0-0', 'O-O')
        pgnAux = pgnAux.replace('0-0-0', 'O-O-O')
        // pgnAux = pgnAux.replace(/\{( *)\}/gmu, '')
        // pgnAux = pgnAux.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
        this.myPGNValue = pgnAux
        var headers = this.parse_pgn_header(idTextArea.value)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          this.myFENValue = headers['FEN']
          // window.alert(headers['FEN'])
        }
        // window.alert(idTextArea.value)
        idTextArea.value = ''
      }
      // this.$dispatch('move', {pgn: this.myPGNValue})
      // }
    },
    setFenPosition () {
      if (document.getElementById('iFramePosition')) {
        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
        if (searchinput !== undefined && searchinput !== null) {
          // window.alert(searchinput.value)
          // var idFEN = document.getElementById('myFENValue')
          var txtPgn = ''
          txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]'
          // var idTextArea = document.getElementById('idTextAreaPGN')
          // idTextArea.value = idFEN.value
          this.fenInit = searchinput.value
          this.fenFinish = searchinput.value
          this.pgn = txtPgn
          // idFEN.value = searchinput.value
          // idFEN.textContent = searchinput.value
          // idFEN.dispatchEvent(new window.Event('input'))
          // idTextArea.dispatchEvent(new window.Event('change'))
          // window.alert(txtPgn)
          // this.$broadcast('modal::close', 'some', 'setFen')
        }
      }
    },
    createTorneo (action) {
      if (action) {
        // this.setFenPosition()
        // window.alert('Creando el torneo')
        // validar que no existe uno similar en db
        var newTorneo = {
          type: this.torneoType.type,
          createby: UserService.getUser().username,
          club: UserService.getUser().club,
          incremento: this.newboard.incremento,
          time: this.newboard.time,
          rounds: this.rondas,
          round1: JSON.stringify(this.round1),
          titlefen: this.nombretorneo,
          mode: this.mode
        }
        // this.toast(JSON.stringify(newTorneo), 5000)
        // window.alert(JSON.stringify(newTorneo))
        this.$broadcast('modal::close', 'some', 'modalCreateTorneo')
        TorneoService.add(this, newTorneo).then(function (response) {
          this.toast('<span>Creado correctamente</span>', 3000)
          // actualizar listado
          // this.selectTorneoType(this.torneoType)
          // seleccionar actual
          if (this.mode === 'add' && newTorneo) {
            this.selectItm(newTorneo)
            // this.nextTorneo()
          } else {
            // console.log('selecciona otra vez para ver los cambios')
          }
          // actualizar listado
          // window.alert(JSON.stringify(response.data))
          this.selectTorneoType(this.torneoType)
        }, function (response) {
          this.error = response.data
          this.toast('<span>' + this.error + '</span>', 3000)
        })
      } else {
        this.$broadcast('modal::close', 'some', 'modalCreateTorneo')
      }
    },
    onResize (event) {
      if (document.getElementById('middle') && document.getElementById('torneoBoard')) {
        var Width = document.getElementById('middle').clientWidth
        Width = Width > window.innerHeight - 100 ? window.innerHeight - 100 : Width // document.getElementById('middle').clientWidth
        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
          Width = Width - 35
        }
        document.getElementById('torneoBoard').style.height = Width + 'px'
        document.getElementById('torneoBoard').style.width = Width + 'px'
        // Jquery('#pgnBoard').load(window.location.href + '#pgnBoard')
        // this.toast('<span>Width: ' + Width + '</span>', 2000, 'rounded')
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
    },
    editTorneo () {
      this.pgn = this.item.pgn
      this.fenInit = this.item.feninit
      this.numMoves = this.item.nummoves
      this.timeMove = this.item.timemove
      this.timeFen = this.item.timefen
      this.round1 = this.item.round1
      this.nombretorneo = this.item.titlefen
      this.rondas = this.item.rounds
      this.newboard.time = this.item.time
      this.newboard.incremento = this.item.incremento
      this.timePersonal = true
      // window.alert(this.timeMove)
      this.addTorneo(this.item._id)
      /* setTimeout(function () {
        this.fenInit = this.item.feninit
        if (this.item.fenfinish) {
          this.fenFinish = this.item.fenfinish
        }
      }.bind(this), 1000)*/
    },
    delTorneo () {
      var _self = this
      window.swal('¿Está seguro de eliminar el torneo?', {
        buttons: {
          si: {text: 'Sí', value: 's'},
          no: {text: 'No', value: 'n'}
        }
      }).then(function (resultParam) {
        // window.alert(resultParam)
        if (resultParam === 's') {
          TorneoService.del(_self, _self.item._id).then(function (response) {
            _self.selectTorneoType(_self.torneoType)
          }, function (response) {
            _self.error = response.data
          })
        }
      })
      /* if (window.confirm('Seguro de eliminar')) {
        TorneoService.del(this, this.item._id).then(function (response) {
          this.selectTorneoType(this.torneoType)
        }, function (response) {
          this.error = response.data
        })
      }*/
    },
    createAllTournament () {
      this.rondas = 1
      this.round1 = {}
      for (var x = 0; x < this.rondas; x++) {
        this.createTournament(x)
      }
      this.bGuardar = true
    },
    addPlayersInRound (round1) {
      for (var ronda in round1) {
        for (var partida in round1[ronda].rounds) {
          var nameBlack = round1[ronda].rounds[partida].black
          var nameWhite = round1[ronda].rounds[partida].white
          var elo = round1[ronda].rounds[partida].elo
          // window.alert(nameBlack)
          if (nameBlack !== undefined) {
            this.players[nameBlack] = { name: nameBlack, juega: false, user: nameBlack, score: 0, buchholz: 1, elo: elo }
          }
          if (nameWhite !== undefined) {
            this.players[nameWhite] = { name: nameWhite, juega: false, user: nameWhite, score: 0, buchholz: 1, elo: elo }
          }
        }
      }
    },
    clone (obj) {
      var dupe = (obj instanceof Array) ? [] : {}
      for (var property in obj) {
        if (typeof property === 'object') {
          dupe[property] = this.clone(obj[property])
        } else {
          dupe[property] = obj[property]
        }
      }
      return dupe
    },
    refresh () {
      this.selectItm(this.item)
    },
    showResults (round1, title) {
      // window.alert(JSON.stringify(round1))
      this.nombreTorneoResult = title
      this.playersResult = {}
      /* for (var i in this.playersResult) {
        this.playersResult[i].score = 0
      }*/
      for (var ronda in round1) {
        for (var partida in round1[ronda].rounds) {
          var nameBlack = round1[ronda].rounds[partida].black
          var nameWhite = round1[ronda].rounds[partida].white
          var elo = round1[ronda].rounds[partida].elo
          if (nameBlack !== undefined && this.playersResult[nameBlack] === undefined) {
            this.playersResult[nameBlack] = { name: nameBlack, juega: false, user: nameBlack, score: 0, buchholz: 1, elo: elo }
          }
          if (nameWhite !== undefined && this.playersResult[nameWhite] === undefined) {
            this.playersResult[nameWhite] = { name: nameWhite, juega: false, user: nameWhite, score: 0, buchholz: 1, elo: elo }
          }
          if (round1[ronda] !== undefined && round1[ronda].rounds[partida].wins !== '') {
            if (round1[ronda].rounds[partida].wins === 'white') {
              if (this.playersResult[nameWhite] !== undefined) {
                this.playersResult[nameWhite].score += 1
              }
              if (this.playersResult[nameBlack] !== undefined) {
                this.playersResult[nameBlack].score -= 0
              }
            } else if (round1[ronda].rounds[partida].wins === 'black') {
              if (this.playersResult[nameWhite] !== undefined) {
                this.playersResult[nameWhite].score -= 0
              }
              if (this.playersResult[nameBlack] !== undefined) {
                this.playersResult[nameBlack].score += 1
              }
            } else if (round1[ronda].rounds[partida].wins === 'draw') {
              if (this.playersResult[nameBlack] !== undefined) {
                this.playersResult[nameBlack].score += 0.5
              }
              if (this.playersResult[nameWhite] !== undefined) {
                this.playersResult[nameWhite].score += 0.5
              }
            }
          }
        }
      }
      for (ronda in round1) {
        for (partida in round1[ronda].rounds) {
          nameBlack = round1[ronda].rounds[partida].black
          nameWhite = round1[ronda].rounds[partida].white
          if (this.playersResult[nameWhite] !== undefined) {
            this.playersResult[nameWhite].buchholz = 0
          }
          if (this.playersResult[nameBlack] !== undefined) {
            this.playersResult[nameBlack].buchholz = 0
          }
        }
      }
      for (ronda in round1) {
        for (partida in round1[ronda].rounds) {
          nameBlack = round1[ronda].rounds[partida].black
          nameWhite = round1[ronda].rounds[partida].white

          if (this.playersResult[nameWhite] !== undefined && this.playersResult[nameBlack] !== undefined) {
            this.playersResult[nameWhite].buchholz += this.playersResult[nameBlack].score
            this.playersResult[nameBlack].buchholz += this.playersResult[nameWhite].score
          }
        }
      }
      let ordered = {}
      var _self = this
      Object.keys(_self.playersResult).sort((a, b) => {
        if (_self.playersResult[b].score === _self.playersResult[a].score) {
          return _self.playersResult[b].buchholz - _self.playersResult[a].buchholz
        } else {
          return _self.playersResult[b].score - _self.playersResult[a].score
        }
      }).forEach(function (key) {
        ordered[key] = _self.playersResult[key]
      })
      this.playersResult = ordered
      this.$broadcast('modal::open', 'modalResultados')
      // window.alert(JSON.stringify(ordered))
    },
    roundRobin (teams) {
      let schedule = []
      let league = []
      var rondaRoundRobin = {}
      for (var i in this.players) {
        if (this.players[i].juega === true) {
          league.push(this.players[i].name)
        }
      }
      // var league = teams// .slice()
      if (league.length % 2) {
        league.push('None')
      }
      let rounds = league.length
      // window.alert(rounds)
      this.rondas = rounds
      var totalRondas = this.bOneRound === true ? (rounds - 1) : (rounds - 1) * 2
      for (var j = 0; j < totalRondas; j++) {
        schedule[j] = []
        var round = {}
        for (let i = 0; i < rounds / 2; i++) {
          // var partidas = 0
          // window.alert(JSON.stringify(league[i]))
          if (league[i] !== 'None' && league[rounds - 1 - i] !== 'None') {
            var white = ''
            var black = ''
            if (j % 2 === 1) {
              schedule[j].push([league[i], league[rounds - 1 - i]])
              white = league[i]
              black = league[rounds - 1 - i]
            } else {
              schedule[j].push([league[rounds - 1 - i], league[i]])
              white = league[rounds - 1 - i]
              black = league[i]
            }
            var partida = {white: white, black: black, wins: ''}
            round[i] = partida
            // partidas++
          }
        }
        // window.alert(j)
        var roundaux = { rounds: round }
        rondaRoundRobin[j] = roundaux
        league.splice(1, 0, league.pop())
      }

      if (this.players['PC'] === undefined) {
        this.players['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 }
      }
      this.round1 = rondaRoundRobin

      // window.alert(JSON.stringify(schedule))
      return schedule
    },
    saveTournament () {
    },
    createRoundRobin () {
      var ret = this.randomArrayShuffle(this.players)
      this.players = ret
      this.roundRobin(this.players)
      this.bGuardar = true
    },
    createSwiss () {
      var retP = this.randomArrayShuffle(this.players)
      this.players = retP
      this.rondas = 1
      // this.roundRobin(this.players)
      var ret = {}
      var param = this.round1
      this.round1 = {}
      ret = Swiss.createSwiss(this.players, param, 0)
      // window.alert(JSON.stringify(ret))
      for (var k in ret) {
        Vue.set(this.round1, k, ret[k])
      }
      // window.alert(this.round1)
      this.bGuardar = false
    },
    createTournament (ronda) {
      // var mensaje = 'rondas: ' + this.rondas + ' tiempo: ' + this.newboard.time + ' inc: ' + this.newboard.incremento
      // window.alert(ronda)
      var jugadores = ''
      var partidas = 0
      var white = ''
      var black = ''
      var round = {}
      // this.shuffleVueArray(this.players)
      var ret = this.randomArrayShuffle(this.players)
      this.players = ret
      for (var i in this.players) {
        if (this.players[i].juega === true) {
          jugadores += '(' + i + ') ' + this.players[i].name + ': ' + this.players[i].juega + '\n'
          if (this.bSimultanea === true) {
            if (UserService.getUser().username !== this.players[i].name) {
              if (this.bRandColor === true && ((Math.random() * 10) > 4)) {
                black = UserService.getUser().username
                white = this.players[i].name
              } else {
                white = UserService.getUser().username
                black = this.players[i].name
              }
              var partida = {white: white, black: black, wins: ''}
              round[partidas] = partida
            }
          } else {
            if (partidas % 2 === 0) {
              white = this.players[i].name
            } else {
              black = this.players[i].name
              partida = {white: white, black: black, wins: ''}
              round[partidas] = partida
            }
          }
          partidas++
        }
      }
      if (this.players['PC'] === undefined) {
        this.players['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 }
      }
      // window.alert('Creando el torneo: ' + mensaje + '\n' + 'Jugadores: \n' + jugadores)
      // window.alert(JSON.stringify(round))
      var roundaux = { rounds: round }
      this.round1[ronda] = roundaux
      // this.round1[ronda].rounds = round
      // this.createdInviteGame(white, black)
    },
    randomArrayShuffle (arrayParam) {
      var array = []
      var arrayRet = {}
      var index = 0
      for (var ii in arrayParam) {
        // window.alert(JSON.stringify(arrayParam[ii]))
        array.push(arrayParam[ii].name)
        index++
      }
      var currentIndex = this.getLength(array) - 1

      while (currentIndex > 0) {
        const randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        const temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }
      for (let i = this.getLength(array) - 1; i >= 0; i--) {
        arrayRet[array[i]] = arrayParam[array[i]]
      }
      return arrayRet
    },
    createInvites (rondaParam, round1, torneo) {
      this.rondaactual = rondaParam - 1
      // window.alert(JSON.stringify(this.rondaactual))
      var _self = this
      window.swal(torneo + '\n¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?', {
        buttons: {
          si: {text: 'Sí', value: 's'},
          no: {text: 'No', value: 'n'}
        }
      }).then(function (resultParam) {
        // window.alert(resultParam)
        if (resultParam === 's') {
          var rondaInvites = round1[_self.rondaactual]
          _self.nombretorneo = torneo
          // window.alert(JSON.stringify(rondaInvites))
          for (var i in rondaInvites.rounds) {
            _self.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black)
          }
        }
      })
      /* if (window.confirm(torneo + '\n¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?')) {
        // window.alert(JSON.stringify(round1))
        var rondaInvites = round1[this.rondaactual]
        this.nombretorneo = torneo
        for (var i in rondaInvites.rounds) {
          this.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black)
        }
      }*/
    },
    createInvitesNextSwiss (round1, torneo) {
      this.rondas = 1
      this.nombretorneo = torneo
      // this.roundRobin(this.players)
      // window.alert(JSON.fresulstringify(round1))
      Swiss.createSwiss(this.players, round1, 1)
      // window.alert(JSON.stringify(ret))
      // this.createRoundRobin()
      this.createTorneo(true)
      this.bGuardar = true
      this.rondaactual = 2// rondaParam - 1
      // (JSON.stringify(this.round1))
      this.bGuardar = true
    },
    createdInviteGame (userNameWhite, userNameBlack) {
      // var userWhite = this.players[userNameWhite].user
      // var userBlack = this.players[userNameBlack].user
      // window.alert(JSON.stringify(this.item))
      var invite = {
        type: 'invite',
        public: this.item.public,
        broadcast: false,
        all: true,
        vsPc: false,
        torneo: this.nombretorneo,
        ronda: this.rondaactual,
        confirm: false,
        club: UserService.getUser().club,
        time: this.item.time,
        incremento: this.item.incremento,
        recibe: this.active,
        elo: UserService.getUser().elo
      }
      if (userNameWhite/* .substring(0, 2) */ === 'PC') {
        invite.vsPc = true
        invite.confirm = true
        // window.alert(this.newboard.elo)
        invite.elo = this.item.elo
      }
      // var userActive = userNameWhite
      // UserService.setUser(userActive)
      // var bFound = false
      if (userNameBlack !== '') {
        invite.confirm = true
        if (userNameBlack/* .substring(0, 2) */ === 'PC') {
          invite.vsPc = true
          invite.elo = this.item.elo
          // userActive = 'PC'
          // bFound = true
        }
        /* else {
          for (var i in this.users) {
            if (this.users[i].nickname === userNameBlack) {
              userActive = this.users[i].nickname
              bFound = true
              alert(userActive)
            }
          }
        }*/
        /* if (bFound === false) {
          // window.alert('error')
          // this.$broadcast('modal::close', 'some', 'inviteGame')
          return
        }*/
      }
      if (this.newboard.color === 'w') {
        invite.u1 = userNameWhite
        invite.u2 = userNameBlack
      } else {
        invite.u2 = userNameWhite
        invite.u1 = userNameBlack
      }
      /* var data = {
        c: 'board',
        f: 'inviteGame',
        data: {
          event: 'inviteGame',
          data: invite
        }
      }*/
      // window.alert(JSON.stringify(invite))
      if (invite.confirm === true) {
        this.InviteGameActionConfirmado(invite)
      }
    },
    InviteGameActionConfirmado (invite) {
      // preparar tablero
      var data = {
        c: 'board',
        f: 'confirmGame',
        data: invite
      }
      // window.alert('InviteGameActionConfirmado' + JSON.stringify(invite))
      if (invite.confirm || invite.vsPc) {
        data.f = 'addBoard'
        // this.deleteInvite(invite)
      } else {
        // this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded')
      }
      this.$socket.emit('event', data, function (...callbacks) {
        if (callbacks[0]) {
          // window.alert(callbacks[0])
          // window.alert(JSON.Stringify(invite))
        }
      })
      // this.deleteInvite(invite)
      // eliminar invitacion del arreglo
    },
    getLength (param) {
      var ret = 0
      if (param !== undefined && Object.keys(param) !== undefined) {
        ret = Object.keys(param).length
      }
      return ret
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      var ret = ''
      if (name !== undefined) {
        ret = this.dirServer + '/uploads/' + name
      }
      return ret
    },
    loadAllData () {
      var data = {
        c: 'chat',
        f: 'getDataChat',
        data: {
          user: UserService.getUser()
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            /* var logUser = callbacks[1].logUser
            for (var i = 0; i < logUser.length; i++) {
              if (logUser[i]) {
                // this.openTab({nickname: logUser[i]}, false)
                /* var parmsLoad = {
                  user: logUser[i],
                  range: {
                    limit: 30,
                    skip: 0
                  }
                }
                // this.loadUserConvert(parmsLoad)
              }
            }*/
            // this.loadUserClubData(callbacks[1].boards)
            this.boards = callbacks[1].boards
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    loadUserConvert (parms, historyTop = false) {
      var data = {
        c: 'chat',
        f: 'loadUserConvert',
        data: parms
      }
      this.$socket.emit('event', data, function (...callbacks) {
        var log = callbacks[1]
        /* if (historyTop) {
          // adiciona mensajes al principio de la conversacion
          var post = this.foundTab(this.active)
          if (log.length > 0) {
            Jquery('#content_' + this.active).animate({
              'scrollTop': 100
            }, 'slow')
          }
          var menHistory = log.concat(this.tabs[post].men)
          this.tabs[post].men = menHistory
        } else {*/
        // Recoger todos los mensajes antiguos
        var menLast = ''
        if (log) {
          for (var i = log.length - 1; i >= 0; i--) {
            if (menLast !== log[i].body && log[i].board === this.board._id) {
              this.recibeMensaje(log[i], true, false)
              menLast = log[i].body
            }
          }
        }
        // }
      }.bind(this))
    }
  },
  ready () {
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    document.title = 'Mainchess - ' + this.$t('tournament.title')
  },
  created () {
    window.addEventListener('resize', this.onResize)
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    // window.alert(this.classBoard)
    this.$nextTick(function () {
      this.active = 'boardVisor'
      this.loadAllData()
    })
    this.$dispatch('userLoguin', 'show data')
    this.bGuardar = false
    /* this.$nextTick(function () {
      this.showBoard()
    })*/
  },
  computed: {
    filteredAndOrderedUsers () {
      if (!this.users) return []
      // Filtra los usuarios
      let filtered = this.users.filter(user =>
        user.username.toLowerCase().includes(this.finduser.toLowerCase()) && (this.conectados === false || this.isConnected(user.username))
      )
      // Ordena los usuarios
      filtered.sort((a, b) => a.username.localeCompare(b.username))
      return filtered
    }
  },
  watch: {
    round1 (val, oldVal) {
      this.round1 = val
      // window.alert(val)
    },
    myFENValue (val, oldVal) {
      this.fenInit = val
      // window.alert(val)
    },
    myPGNValue (val, oldVal) {
      this.pgn = val
      // window.alert(this.pgn)
      setTimeout(function () {
        var pgnBoardInit = 0
        if (document.getElementById('pgnMoves')) {
          document.getElementById('pgnMoves').textContent = ''
        }
        if (document.getElementById('pgnButtons')) {
          document.getElementById('pgnButtons').textContent = ''
        }
        if (document.getElementById('pgnHeader')) {
          document.getElementById('pgnHeader').textContent = ''
        }
        var pos = 'start' // board.fen !== undefined ? board.fen : 'end'
        var start = 'start'
        var pgnNew = this.pgn.split('"]').join('"]\n')
        pgnNew = pgnNew.split('{}').join('')
        var headers = this.parse_pgn_header(pgnNew)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          pos = headers['FEN']
        } else {
          // window.alert(board.fen + ' ' + start)
        }
        if (start === pos) {
          start = 0
        }
        if (this.fenInit !== '' && this.fenInit !== undefined) {
          start = this.fenInit
        }
        try {
          var winWidth = Math.min(window.innerWidth, window.outerWidth)
          pgnBoardInit = window.pgnEdit({inner: 'torneoGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons', header: 'pgnHeader'}, {pgn: this.pgn, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true})
          groundInit = pgnBoardInit.board
          window.pgnBoardBase = pgnBoardInit.boardBase
          window.ground = pgnBoardInit.board
          // window.alert(pgnBoardInit.boardBase.currentMove)
          /* setTimeout(function () {
            document.getElementById('pgnButtonslast').click()
          }, 100)*/
        } catch (error) {
          // this.toast('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000)
          console.error('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000)
        }
      }.bind(this), 50)
    },
    fenInit (newVal, oldVal) {
      if (newVal === '') {
        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      }
      /* groundInit.set({
        fen: newVal
      })*/
    },
    fenFinish (newVal, oldVal) {
      if (newVal === '') {
        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      }
      /* groundFinish.set({
        fen: newVal
      }) */
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/libs/simplechessboard.min.css';
h1 {
  color: #42b983;
}
/*
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;
  &:before {
    content: '';
    // use the linear-gradient for the fading effect
    // use a solid background color for a solid bar
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;

    padding: 0 .5em;
    line-height: 1.5em;
    // this is really the only tricky part, you need to specify the background color of the container element...
    color: #818078;
    background-color: #fcfcfa;
  }
}*/
</style>



// WEBPACK FOOTER //
// index.vue?4e54b20b